"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-calogero": {
    "76f519ba": [{
      "hkey": "821ad10e",
      "slug": "san-calogero",
      "name": "San Calogero",
      "primary": true,
      "skipSearch": false
    }],
    "casalello": [{
      "hkey": "821ad10e",
      "slug": "san-calogero",
      "name": "San Calogero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "22d72298": [{
      "hkey": "821ad10e",
      "slug": "san-calogero",
      "name": "San Calogero",
      "primary": true,
      "skipSearch": false
    }],
    "sant-opoli": [{
      "hkey": "821ad10e",
      "slug": "san-calogero",
      "name": "San Calogero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c83c5ba5": [{
      "hkey": "821ad10e",
      "slug": "san-calogero",
      "name": "San Calogero",
      "primary": true,
      "skipSearch": false
    }],
    "torre-di-campo": [{
      "hkey": "821ad10e",
      "slug": "san-calogero",
      "name": "San Calogero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;